import { camelCase } from '../util.js'
const works = [
  {
    title: '我要做件轰轰烈烈的大事 跨域半个地球来见你',
    desc: '我要做件轰轰烈烈的大事 跨域半个地球来见你',
    thumb: camelCase('cases-brand-hpnk-0'),
    zpic: [
      camelCase('cases-brand-hpnk-lazyload-01'),
      camelCase('cases-brand-hpnk-lazyload-02'),
      camelCase('cases-brand-hpnk-lazyload-03')
    ]
  },
  {
    title: '精萃点滴营养 呵护宝宝成长',
    desc: '精萃点滴营养 呵护宝宝成长',
    thumb: camelCase('cases-brand-hpnk-1'),
    zpic: [
      camelCase('cases-brand-hpnk-lazyload-11')
    ]
  },
  {
    title: '红罐五侠',
    desc: '旗开得胜 实力出道z',
    thumb: camelCase('cases-brand-hpnk-2'),
    zpic: [
      camelCase('cases-brand-hpnk-lazyload-21')
    ]
  },
  {
    title: '万物都是相对的吗？',
    desc: '不，萃护三不添加是绝对的!',
    thumb: camelCase('cases-brand-hpnk-3'),
    zpic: [
      camelCase('cases-brand-hpnk-lazyload-31')
    ]
  },
  {
    title: '萃护系列',
    desc: '萃护系列',
    thumb: camelCase('cases-brand-hpnk-4'),
    zpic: [
      camelCase('cases-brand-hpnk-lazyload-41'),
      camelCase('cases-brand-hpnk-lazyload-42'),
      camelCase('cases-brand-hpnk-lazyload-43'),
      camelCase('cases-brand-hpnk-lazyload-44'),
      camelCase('cases-brand-hpnk-lazyload-45'),
      camelCase('cases-brand-hpnk-lazyload-46'),
      camelCase('cases-brand-hpnk-lazyload-47'),
      camelCase('cases-brand-hpnk-lazyload-48'),
      camelCase('cases-brand-hpnk-lazyload-49'),
      camelCase('cases-brand-hpnk-lazyload-410'),
      camelCase('cases-brand-hpnk-lazyload-411'),
      camelCase('cases-brand-hpnk-lazyload-412'),
      camelCase('cases-brand-hpnk-lazyload-413'),
      camelCase('cases-brand-hpnk-lazyload-414'),
      camelCase('cases-brand-hpnk-lazyload-415'),
      camelCase('cases-brand-hpnk-lazyload-416')
    ]
  },
  {
    title: '出类拔萃',
    desc: '出类拔萃',
    thumb: camelCase('cases-brand-hpnk-5'),
    zpic: [
      camelCase('cases-brand-hpnk-lazyload-51'),
      camelCase('cases-brand-hpnk-lazyload-52')
    ]
  },
  {
    title: '肚肚舒适心情好',
    desc: '肚肚舒适心情好',
    thumb: camelCase('cases-brand-hpnk-6'),
    zpic: [
      camelCase('cases-brand-hpnk-lazyload-61'),
      camelCase('cases-brand-hpnk-lazyload-62'),
      camelCase('cases-brand-hpnk-lazyload-63'),
      camelCase('cases-brand-hpnk-lazyload-64'),
      camelCase('cases-brand-hpnk-lazyload-65'),
      camelCase('cases-brand-hpnk-lazyload-66'),
      camelCase('cases-brand-hpnk-lazyload-67'),
      camelCase('cases-brand-hpnk-lazyload-68'),
      camelCase('cases-brand-hpnk-lazyload-69')
    ]
  },
  {
    title: '肚肚舒适心情好',
    desc: '肚肚舒适心情好',
    thumb: camelCase('cases-brand-hpnk-7'),
    zpic: [
      require('../../assets/cases-brand-hpnk-lazyload-71.mp4')
    ]
  }
]
export default {
  name: '海普诺凯',
  logo: {
    default: camelCase('cases-brand-20'),
    active: camelCase('cases-brand-20-cover')
  },
  works
}
